import { domToPng } from 'modern-screenshot'

export interface ImageGeneratorOptions {
  fileName?: string
  onProgress?: (progress: number, message: string) => void
  quality?: number
  scale?: number
}

export async function generateReportImageDataUrl(
  elementId: string = 'report',
  options: ImageGeneratorOptions = {}
): Promise<string> {
  let element: HTMLElement | null = null
  const originalStyle = {
    width: '',
    minWidth: '',
    maxWidth: '',
  }

  try {
    options.onProgress?.(0, '正在准备报告...')

    element = document.getElementById(elementId)
    if (!element) {
      throw new Error(`找不到ID为 "${elementId}" 的元素`)
    }

    originalStyle.width = element.style.width
    originalStyle.minWidth = element.style.minWidth
    originalStyle.maxWidth = element.style.maxWidth

    element.setAttribute('data-image-export', 'true')
    element.style.cssText += `
      width: 1024px !important;
      min-width: 1024px !important;
      max-width: 1024px !important;
    `

    void element.offsetHeight

    await new Promise((resolve) => setTimeout(resolve, 300))

    options.onProgress?.(10, '等待图片加载...')
    const images = element.querySelectorAll('img')
    const imageLoadPromises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve()
      return new Promise((resolve) => {
        img.onload = resolve
        img.onerror = resolve
      })
    })
    await Promise.all(imageLoadPromises)

    options.onProgress?.(20, '等待图表渲染...')
    await new Promise((resolve) => setTimeout(resolve, 500))
    const canvases = element.querySelectorAll('canvas')
    if (canvases.length > 0) {
      await new Promise((resolve) => setTimeout(resolve, 1000))
    }

    options.onProgress?.(40, '正在生成图片...')

    const dataUrl = await domToPng(element, {
      scale: options.scale || 2,
      quality: options.quality || 1,
      backgroundColor: '#ffffff',
    })

    element.removeAttribute('data-image-export')
    element.style.cssText = ''
    if (originalStyle.width) element.style.width = originalStyle.width
    if (originalStyle.minWidth) element.style.minWidth = originalStyle.minWidth
    if (originalStyle.maxWidth) element.style.maxWidth = originalStyle.maxWidth

    options.onProgress?.(100, '生成完成!')

    return dataUrl
  } catch (error) {
    if (element) {
      element.removeAttribute('data-image-export')
      element.style.cssText = ''
      if (originalStyle.width) element.style.width = originalStyle.width
      if (originalStyle.minWidth) element.style.minWidth = originalStyle.minWidth
      if (originalStyle.maxWidth) element.style.maxWidth = originalStyle.maxWidth
    }
    console.error('图片生成失败:', error)
    throw error
  }
}
